<template>
	<div class="page">
		<gc-header headerData="omPlatformInformationDetails"></gc-header>
		<div class="page-main">
			<gc-group-detail :data="basicInfoData"></gc-group-detail>
			<el-radio-group v-model="tabIndex" size="medium">
				<el-radio-button :label="0">关联设备组</el-radio-button>
				<el-radio-button :label="1">操作日志</el-radio-button>
			</el-radio-group>
			<div class="table-content" v-loading="loading">
				<gc-table
					border
					:showPage="true"
					:columns="tabIndex === 0 ? deviceGroupColumns : operateLogColumns"
					:table-data="tableData"
					:total="pagination.total"
					:pageSize="pagination.pageSize"
					gloabSortDisable
					paginationLayout="prev, next, jumper"
					@current-page-change="handleCurrentPageChange"
				></gc-table>
			</div>
		</div>
	</div>
</template>

<script>
import {
	apiGetPlatfromProductDetails,
	apiGetDeviceGroupPageList,
	apiGetOperateLogPageList,
} from '@/apis/communicationModelManage.api'
export default {
	name: 'omPlatformInformationDetails',
	data() {
		return {
			platformId: this.$route.query.platformId,
			tabIndex: 0,
			platformDetails: {},
			deviceGroupColumns: [
				{ key: 'deviceGroupName', name: '设备组名称', tooltip: true },
				{ key: 'manufacturerName', name: '厂商' },
				{ key: 'deviceTypeName', name: '设备类型' },
				{
					key: 'status',
					name: '状态',
					render: (h, row) => {
						return h(
							'span',
							{ class: row.status === 0 ? 'dot-error' : 'dot-success' },
							row.status === 0 ? '禁用' : '启用',
						)
					},
				},
				{ key: 'createStaffName', name: '创建人' },
				{
					key: 'oprate',
					name: '操作',
					sortDisable: true,
					width: 240,
					fixed: 'right',
					render: (h, row) => {
						return h('div', null, [
							h(
								'el-button',
								{
									props: { type: 'text', size: 'medium' },
									on: {
										click: () => this.handleDeviceGroupDetails(row.id),
									},
								},
								'详情',
							),
						])
					},
				},
			],
			operateLogColumns: [
				{ key: 'operationType', name: '操作类型' },
				{ key: 'operatorName', name: '操作人' },
				{ key: 'operationTime', name: '操作时间' },
				{ key: 'operationInfo', name: '操作后信息', tooltip: true },
			],
			loading: false,
			pagination: {
				currentPage: 1,
				pageSize: 20,
				total: 0,
			},
			tableData: [],
		}
	},
	computed: {
		basicInfoData() {
			const d = this.platformDetails
			return {
				title: '运营商平台信息',
				row: 4,
				list: [
					{
						key: 'platformName',
						label: '平台名称',
						value: d.platformName,
					},
					{
						key: 'platformType',
						label: '运营商',
						value: d.platformType,
					},
					{
						key: 'appId',
						label: 'APP_ID',
						value: d.appId,
					},
					{
						key: 'productId',
						label: '产品ID',
						value: d.productId,
					},
					{
						key: 'status',
						label: '状态',
						value: d.status === 1 ? '开启' : '禁用',
					},
					{
						key: 'publicFlag',
						label: '权限',
						value: d.publicFlag === 1 ? '公开' : '私有',
					},
					{
						key: 'createStaffName',
						label: '创建人',
						value: d.createStaffName,
					},
					{
						key: 'createdTime',
						label: '创建时间',
						value: d.createdTime,
					},
					{
						key: 'remarks',
						label: '备注',
						value: d.remarks,
						col: 4,
					},
				],
			}
		},

		manufacturerId() {
			return this.$store.getters.userInfo.manufacturerId
		},
	},

	created() {
		this.queryPlatfromProductDetails()
		this.queryTableDataPageList()
	},

	methods: {
		async queryPlatfromProductDetails() {
			const data = await apiGetPlatfromProductDetails(this.platformId)
			this.platformDetails = data
		},

		async queryTableDataPageList() {
			this.loading = true
			const API = this.tabIndex === 0 ? apiGetDeviceGroupPageList : apiGetOperateLogPageList
			const searchParams = {
				current: this.pagination.currentPage,
				size: this.pagination.pageSize,
				platformId: this.platformId,
				manufacturerId: this.manufacturerId,
				logType: '1',
				relatedId: this.platformId,
			}
			try {
				const { records = [], total } = await API(searchParams)
				this.tableData = records
				this.pagination.total = total
			} finally {
				this.loading = false
			}
		},

		handleCurrentPageChange(current) {
			this.pagination.currentPage = current
			this.queryTableDataPageList()
		},

		handleDeviceGroupDetails(id) {
			this.$router.push({
				path: '/communication-model-manage/device-group/details',
				query: {
					id,
				},
			})
		},
	},

	watch: {
		tabIndex() {
			this.tableData = []
			this.pagination.currentPage = 1
			this.queryTableDataPageList()
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../../run-manage/runLayout.scss';
.page-main {
	flex-direction: column;
	padding: 0 20px;
	.table-content {
		flex: 1;
		height: 0;
		padding: 12px 0;
	}
}
</style>
